const React = require('react');
const classnames = require('classnames');
const ICON_SIZE = 12;
import HttpsProtocolImage from './https-protocol-image';

const BtnShortcutDefault = React.createClass({
  displayName: 'BtnShortcutDefault',
  propTypes: {
    btnAttributes: React.PropTypes.object,
    children: React.PropTypes.array,
    disabled: React.PropTypes.bool,
    mainButton: React.PropTypes.bool,
    isChildrenShow: React.PropTypes.bool,
    isNavi: React.PropTypes.bool,
  },

  getComponentClassName() {
    const { btnAttributes = {}, disabled, mainButton, isChildrenShow, isNavi } = this.props;
    const classNames = [isNavi ? 'btn-shortcut-navi' : 'btn-shortcut'];

    [].push.apply(classNames, [`btn-shortcut-${btnAttributes.size || 'default'}`, `${btnAttributes.classnames || ''}`]);

    if (disabled) {
      classNames.push('btn-shortcut--disabled');
    }

    if (mainButton && isChildrenShow) {
      classNames.push('btn-shortcut--bordered');
    }

    return classNames.join(' ').trim();
  },

  handleTouchTap(evt) {
    const { disabled, btnAttributes = {} } = this.props;
    if (disabled) {
      return;
    }

    if (disabled && btnAttributes.text === '选好啦') {
      return;
    }

    if (evt) {
      evt.preventDefault();
    }

    const { onClick } = btnAttributes;
    if (onClick) {
      onClick();
    }
  },

  render() {
    const { btnAttributes, mainButton } = this.props;
    const defaultIconSize = `${ICON_SIZE}px`;

    return (
      <div className={this.getComponentClassName()} onTouchTap={this.handleTouchTap}>
        {btnAttributes.icon && (
          <HttpsProtocolImage
            className="btn-shortcut-icon"
            style={{ width: `${btnAttributes.iconWidth || defaultIconSize}`, verticalAlign: `${btnAttributes.verticalAlign || ''}` }}
            src={btnAttributes.icon}
            role="presentation"
          />
        )}
        {!mainButton && btnAttributes.childIcon && <img className="btn-shortcut-childicon" src={btnAttributes.childIcon} alt={btnAttributes.text} />}
        {btnAttributes.text && (
          <span
            className={classnames('btn-shortcut-text', {
              'btn-sync-yellow': btnAttributes.moduleBg,
            })}
          >
            {btnAttributes.text}
          </span>
        )}
        {this.props.bell ? this.props.bell : null}
      </div>
    );
  },
});

module.exports = BtnShortcutDefault;



// WEBPACK FOOTER //
// ./src/component/common/btn-shortcut-default.jsx